import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    list: [],
    meta: {},
    userDetails: {},
    teamDrivers: {
      list: [],
      meta: {},
    },
    pointsDetails: {
      list: [],
      meta: {},
    },
    rewardsDetails: {
      list: [],
      meta: {},
    },
    rejectedDrivers: {
      modalOpen: false,
      driversData: null,
      qualifiedDriversCount: 0,
    },
    pendingDrivers: {
      list: [],
      meta: {},
    },
    requestsDetails: {
      list: [],
      meta: {},
    },
    referralRewards: {
      list: [],
      meta: {},
    },
    licenseVerification: {
      licenseNumber: null,
      currentlyExist: false,
      previouslyExist: false,
      isVerified: false,
    },
    vehicles: {
      list: [],
      meta: {},
    },
  },
  reducers: {
    getUsersListRequest: () => {},
    getUsersListResponse: (state, action) => {
      state.list = action.payload.users;
      state.meta = action.payload.meta;
    },
    getUserDetailsRequest: () => {},
    getUserDetailsResponse: (state, action) => {
      state.userDetails = action.payload;
    },
    getTeamDriversListRequest: () => {},
    getTeamDriversListResponse: (state, action) => {
      state.teamDrivers.list = action.payload.drivers;
      state.teamDrivers.meta = action.payload.meta;
    },
    getDriverPointsListRequest: () => {},
    getDriverPointsListResponse: (state, action) => {
      state.pointsDetails.list = action.payload.points;
      state.pointsDetails.meta = action.payload.meta;
    },
    getDriverRewardsListRequest: () => {},
    getDriverRewardsListResponse: (state, action) => {
      state.rewardsDetails.list = action.payload.rewards;
      state.rewardsDetails.meta = action.payload.meta;
    },
    editUserRequest: () => {},
    editUserResponse: (state, action) => {
      state.userDetails = action.payload;
    },
    bulkEditDriversRequest: () => {},
    qualifyDriverByPhoneNumberRequest: () => {},
    qualifyDriversBySheetRequest: () => {},
    setRejectedDriversData: (state, action) => {
      state.rejectedDrivers.modalOpen = action.payload.modalOpen;
      state.rejectedDrivers.driversData = action.payload.driversData;
      state.rejectedDrivers.qualifiedDriversCount =
        action.payload.qualifiedDriversCount;
    },
    getPendingDriversRequest: () => {},
    getPendingDriversResponse: (state, action) => {
      state.pendingDrivers.list = action.payload.users;
      state.pendingDrivers.meta = action.payload.meta;
    },
    editPendingDriverRequest: () => {},
    getDriverRequestsListRequest: () => {},
    getDriverRequestsListResponse: (state, action) => {
      state.requestsDetails.list = action.payload.requests;
      state.requestsDetails.meta = action.payload.meta;
    },
    updateDriverRequest: () => {},
    getReferralRewardsListRequest: () => {},
    getReferralRewardsListResponse: (state, action) => {
      state.referralRewards.list = action.payload.referralRewards;
      state.referralRewards.meta = action.payload.meta;
    },
    verifyDriverLicenseRequest: () => {},
    verifyDriverLicenseResponse: (state, action) => {
      state.licenseVerification.licenseNumber = action.payload.licenseNumber;
      state.licenseVerification.currentlyExist = action.payload.currentlyExist;
      state.licenseVerification.previouslyExist =
        action.payload.previouslyExist;
      state.licenseVerification.isVerified = action.payload.isVerified;
    },
    getVehiclesListRequest: () => {},
    getVehiclesListResponse: (state, action) => {
      state.vehicles.list = action.payload.vehicles;
      state.vehicles.meta = action.payload.meta;
    },
    flagUserRequest: () => {},
  },
});

export const {
  getUsersListRequest,
  getUsersListResponse,
  getUserDetailsRequest,
  getUserDetailsResponse,
  editUserRequest,
  editUserResponse,
  getTeamDriversListRequest,
  getTeamDriversListResponse,
  getDriverPointsListRequest,
  getDriverPointsListResponse,
  getDriverRewardsListRequest,
  getDriverRewardsListResponse,
  bulkEditDriversRequest,
  qualifyDriverByPhoneNumberRequest,
  qualifyDriversBySheetRequest,
  setRejectedDriversData,
  getPendingDriversRequest,
  getPendingDriversResponse,
  editPendingDriverRequest,
  getDriverRequestsListRequest,
  getDriverRequestsListResponse,
  updateDriverRequest,
  getReferralRewardsListRequest,
  getReferralRewardsListResponse,
  verifyDriverLicenseRequest,
  verifyDriverLicenseResponse,
  getVehiclesListRequest,
  getVehiclesListResponse,
  flagUserRequest,
} = userSlice.actions;
export default userSlice.reducer;
